import axios from 'axios'
import { useAuthStore } from '../../stores/auth'

// Crée une instance Axios
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_URPS_API_URL ?? 'http://localhost:3030/api', // URL de base pour toutes vos requêtes
  timeout: 30000, // Temps d'attente (ms)
})

// Ajouter des interceptors si nécessaire (par exemple, pour les tokens JWT)
axiosInstance.interceptors.request.use(
  (config) => {
    // Vérifier si la première requête utilise HTTP au lieu de HTTPS
    // if (config.baseURL && config.baseURL.startsWith('http://')) {
    //   console.warn('Correction de la première requête en HTTPS')
    //   config.baseURL = config.baseURL.replace('http://', 'https://')
    // }
    // Ajouter un token d'authentification si disponible
    const authStore = useAuthStore()
    if (authStore.access_token) {
      console.log('Ajout du token:', authStore.access_token)
      config.headers.Authorization = `Bearer ${authStore.access_token}`
    }
    // Désactiver la mise en cache
    config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate'
    config.headers['Pragma'] = 'no-cache'
    config.headers['Expires'] = '0'

    return config
  },
  (error) => {
    console.error('Erreur intercepteur request:', error)
    return Promise.reject(error)
  },
)

export default axiosInstance
